import React from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Modal,
  ModalContent,
  ModalDescription,
} from "semantic-ui-react";
import CustomHeader from "../shared/CustomHeader";

const UnknownVinDialog = ({ handleClose, handleOpen, open }) => {
  const { t } = useTranslation("unknonwnVinDialog");

  return (
    <Modal
      onClose={() => handleClose()}
      onOpen={() => handleOpen()}
      open={open}
      size="mini"
      className="unkmown__vin"
    >
      <ModalContent>
        <ModalDescription>
          <CustomHeader
            title={t("unknownVinTitle")}
            className="unknow__vin-header"
          />
          <p className="unknow__vin-note marginY__medium">
            {t("unknownVinNote")}
          </p>
          <div className="action__btn">
            <Button onClick={handleClose} className="gotit_btn">
              {t("okGotIt")}
            </Button>
          </div>
        </ModalDescription>
      </ModalContent>
    </Modal>
  );
};

export default UnknownVinDialog;
